import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as Enums from 'src/app/enums';
import { CoreService } from './core.service';


@Injectable({
    providedIn: 'root'
})
export class DashboardsService {

    constructor(
        private http: HttpClient,
        public httpParams: HttpParams
    ) { }

    private headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        api: 'true',
    };

    /**
     * 
     *@param body : { 
            "dt_inicio": "2024-01-01",
            "dt_fim": "2024-05-01",
            "cd_status": "",
            "id_tp_situacao_contrato": "",
        }
     * @returns Observable
     */
    getInventoryDashboardData(body: any) {
        var headers = new HttpHeaders(this.headers);
        return this.http.post(Enums.VARS.API_BASE_URL + 'guard/Dashboards/inventoryDashboardData', body, { headers: headers });
    }

    /**
     * 
     *@param body : { 
            "dt_inicio": "2024-01-01",
            "dt_fim": "2024-05-01",
            "cd_status": "",
            "id_tp_situacao_contrato": "",
        }
     * @returns Observable
     */
    getProductivityDashboardData(body: any) {
        var headers = new HttpHeaders(this.headers);
        return this.http.post(Enums.VARS.API_BASE_URL + 'guard/Dashboards/getProductivityDashboardData', body, { headers: headers });
    }

    /**
     * 
     *@param body : { 
            "dt_inicio": "2024-01-01",
            "dt_fim": "2024-05-01",
            "cd_status": "",
            "id_tp_situacao_contrato": "",
        }
     * @returns Observable
     */
    getInventoryDashboardDataForManager(body: any) {
        var headers = new HttpHeaders(this.headers);
        return this.http.post(Enums.VARS.API_BASE_URL + 'guard/Dashboards/inventoryDashboardDataForManager', body, { headers: headers });
    }

    /**
     * 
     *@param body : { 
            "dt_inicio": "2024-01-01",
            "dt_fim": "2024-05-01",
            "cd_status": "",
            "id_tp_situacao_contrato": "",
        }
     * @returns Observable
     */
    getProductivityDashboardDataForManager(body: any) {
        var headers = new HttpHeaders(this.headers);
        return this.http.post(Enums.VARS.API_BASE_URL + 'guard/Dashboards/getProductivityDashboardDataForManager', body, { headers: headers });
    }

    /**
     * Dashboard de erros capturados pela aplicação (apenas tech_adm).
     * @param params - page, rows, dt_inicio, dt_fim, http_code, user_id, search
     */
    getErrorsDashboardData(params: {
        page?: number;
        rows?: number;
        dt_inicio?: string;
        dt_fim?: string;
        http_code?: number | string;
        user_id?: number | string;
        search?: string;
    }) {
        var headers = new HttpHeaders(CoreService.getDefaultHeader());
        let httpParams = new HttpParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                httpParams = httpParams.set(key, String(value));
            }
        });
        return this.http.get(Enums.VARS.API_BASE_URL + 'guard/dashboards/getErrorsDashboardData', { headers: headers, params: httpParams });
    }

}
